<template>
  <div>

    <div class="text-center">
      <h2>{{contract.title}}</h2>
    </div>

    <div v-html="contractMarkup">
    </div>
<!--     <div style="overflow: auto; max-height: 400px;" v-html="contractMarkup">
    </div> -->

  </br>
</div>
</div>
</template>

<script>
export default {
  name: 'ContractText',
  data() {
    return {
      clicked: false,
      contract: '',
      acceptTerms: ''
    };
  },
  computed: {
    contractMarkup() {
      return this.$store.getters.contractMarkup;
    },
    disableButton() {
      return this.acceptTerms == false;
    }
  },
  methods: {
    contractSigned() {
      this.clicked = true;
    }
  },
  components: {},
  created() {}
};
</script>

<style scoped>
p {
  font-size: 0.8rem;
  color: red;
}
</style>
